export default __webpack_public_path__ + "static/media/right-arrow.013a6107.svg";